import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Connectivity check — runs once on load
console.log("[Supabase] URL:", supabaseUrl ?? "MISSING");
console.log("[Supabase] Key set:", supabaseAnonKey ? `yes (starts with ${supabaseAnonKey.slice(0, 12)}...)` : "MISSING");

if (supabaseUrl && supabaseAnonKey) {
  fetch(`${supabaseUrl}/rest/v1/profiles?limit=1`, {
    headers: { apikey: supabaseAnonKey, Authorization: `Bearer ${supabaseAnonKey}` },
  })
    .then(res => console.log("[Supabase] Reachability check — HTTP", res.status, res.status < 400 ? "✓ reachable" : "⚠ unexpected status — key may be wrong"))
    .catch(err => console.error("[Supabase] Reachability check — FAILED:", err.message));
} else {
  console.error("[Supabase] Cannot connect — URL or key is missing from environment variables.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});
